<template>
  <div :class="['main-content','sn-content',heightC]">
    <el-card v-if="user.status == '2'" class="box-card">
      <div>
        <div class="vertical">
          <i class="el-icon-warning-outline" style="color: orange"></i>
          <router-link :to="{path:'/uac/authc'}" style="color: orange">去认证</router-link>
        </div>
        <p class="tag" style="">企业用户请先进行账号认证，认证通过后，才可以申请云授权码</p>
      </div>
    </el-card>

    <div v-else>
      <el-form ref="form" :model="form" :rules="rules">
        <div class="box-card is-always-shadow">
          <el-form-item label="应用名称：" prop="appliName" class="pxy-form-item pxy-form-item-line">
            <el-input placeholder="请输入应用名称" v-model="form.appliName" style="max-width:300px;width:100%;"
                      size="small"></el-input>
          </el-form-item>
          <!-- <el-form-item  label="应用类型："  prop="appliType" class="pxy-form-item pxy-form-item-line">
             <el-select size="small" v-model="form.appliType" >
               <el-option label="SR共享" :value=2></el-option>
               <el-option label="VR(SteamVR共享)" :value=3></el-option>
             </el-select>
           </el-form-item>-->
          <el-form-item label="渲染类型：" prop="appliType" class="pxy-form-item pxy-form-item-line">
            <el-select size="small" v-model="form.appliType" style="max-width:300px;width:100%;"
                       @change="appliTypeChange">
              <el-option label="SR-3D共享模式" :value=2></el-option>
              <el-option label="SR-WebGL" :value=16></el-option>
              <el-option label="SR-2D共享模式" :value=14></el-option>
            </el-select>
            <el-tooltip effect="light" content="" placement="top-start">
              <div slot="content" class="tip-info">
                SR(3D共享模式-平行云方案)：一台服务器可同时运行多个仿真应用。通常情况下，应用没有集成像素流送方案时，选SR（共享-平行云通用方案）；
                <br/>
                SR(2D共享模式-平行云方案):
                二三维应用均可使用，主要解决带有2D元素的应用的多开，但并发度没有3D应用共享模式高，多数场景下可以替代独占模式。支持预启动功能，支持音频输出，支持数据通道，互动模式，不支持客户端调整分辨率、不支持麦克风、摄像头等设备透传。注意点：1）系统会自动创建用户，用户目录下会有用户目录的残留2）用户正常的用户名不要以LARKXR开头（理论上不会）3）需要使用RDP服务（但端口不需要对外开放），推荐可以修改默认的RDP端口。4）在安全审查较严格的时候可以在配置文件中关闭2D应用共享模式，管理节点配置文件：pxy.render-server.remote-desktop.enable=false。5）每个【2D应用共享】连接会和本地会话之间有流量占用，会占用一定的本地带宽但不明显
                6）进入应用的时间比3D共享模式稍微慢一点点。7）对于单机多卡的资源调度基于操作系统的轮询分配多个GPU资源
              </div>
              <i class="el-icon-question tip-icon"></i>
            </el-tooltip>
          </el-form-item>

          <el-form-item v-if="form.appliType == 16" label="WebGL的网址：" prop="exeFilePath" class="pxy-form-item">
            <el-input v-model="form.exeFilePath" style="width: 300px" class="exeFile" size="small"
                      placeholder="请输入WebGL的网址"></el-input>
            <el-tooltip effect="light" placement="top-start">
              <div slot="content" class="tip-info">
                应用启动后，云渲染画面输出访问网址后的推流
              </div>
              <i class="el-icon-question tip-icon"></i>
            </el-tooltip>
          </el-form-item>

          <el-form-item v-if="form.appliType != 16" label="应用上传：" prop="appliPath" class="pxy-form-item pxy-form-item-line">
            <Simple
              ref="upload"
              @beforeUpload="beforeUpload"
              :chunk-size="chunkSize"
              @success="success"
              :zip-file="form.zipFile"
              appli-id=""
            >
            </Simple>
          </el-form-item>

          <!-- 执行文件路径-->
          <el-form-item v-if="form.appliType != 16"  label="执行文件路径：" prop="exeFilePath" class="pxy-form-item pxy-form-item-line">
            <!--    <el-select size="small" v-model="zipContentListValue" >
                  <el-option v-for="(e,index) in zipContentList" :key="index" :label="e" :value="e"></el-option>
                </el-select>-->
            <el-select v-if="exeFilePathList.length > 0" filterable size="small" v-model="form.exeFilePath"
                       style="width: 300px" placeholder="请选择执行文件路径">
              <el-option v-for="(e,index) in exeFilePathList" :key="index" :label="e" :value="e"></el-option>
            </el-select>
            <el-input v-else v-model="form.exeFilePath" style="width: 300px" class="exeFile" size="small"></el-input>
            <div v-if='maybeUnreal' style="display: inline-block;margin-left: 15px;">
              检测到此程序可能是Unreal引擎，如果是请选择Binaries下的路径。
              <a href="https://www.pingxingyun.com/contribute/detail?topicId=10107&categoryId=3" target="_blank">参考链接</a>
            </div>
            <el-tooltip v-else effect="light" content="" placement="top-start">
              <div v-if="exeTabShowFlag" slot="content" class="tip-info">
                执行文件在程序包中的路径，例：StartApp.exe或者bin\StartApp.exe
              </div>
              <div v-else slot="content" class="tip-info">
                zip包解析执行文件路径异常，请手动填写执行文件在程序包中的路径，例：StartApp.exe或者bin\StartApp.exe
              </div>
              <i class="el-icon-question tip-icon"></i>
            </el-tooltip>
          </el-form-item>
          <!-- &lt;!&ndash; 同步类型&ndash;&gt;
          <el-form-item  label="同步类型："  prop="initiativeSyncFlag" class="pxy-form-item pxy-form-item-line">
            <el-select size="small" v-model="form.initiativeSyncFlag" disabled>
              <el-option label="不主动同步" :value=0></el-option>
              <el-option label="主动同步" :value=1></el-option>
              <el-option label="半主动同步" :value=2></el-option>
            </el-select>
          </el-form-item>-->
<!--          <el-form-item label="规格：" class="pxy-form-item pxy-form-item-line">-->
<!--            <el-radio-group v-model="form.serverStandard" @input="changeServerStandard">-->
<!--              <el-radio label="2k">2K</el-radio>-->
<!--              <el-radio label="4k">4K</el-radio>-->
<!--            </el-radio-group>-->
<!--            &lt;!&ndash; <el-tooltip effect="light" placement="top-start">-->
<!--              <div slot="content" class="tip-info">*手机客户端是否强制横屏</div>-->
<!--              <i class="el-icon-question tip-icon"></i>-->
<!--            </el-tooltip> &ndash;&gt;-->
<!--            <el-tag type="warning">*最高推流分辨率</el-tag>-->
<!--          </el-form-item>-->
          <el-form-item label="无操作超时：" class="pxy-form-item pxy-form-item-line">
            <el-radio v-model="form.noOperaTimeout" :label=5>5分钟</el-radio>
            <el-radio v-model="form.noOperaTimeout" :label=30>30分钟</el-radio>
            <el-radio v-model="form.noOperaTimeout" :label=60>1小时</el-radio>
            <el-radio v-model="form.noOperaTimeout" :label=0>不限制</el-radio>
            <!-- <el-tooltip effect="light" placement="top-start">
              <div slot="content" class="tip-info">*手机客户端是否强制横屏</div>
              <i class="el-icon-question tip-icon"></i>
            </el-tooltip> -->
            <el-tag type="warning">*多少时间不操作画面自动断开</el-tag>
          </el-form-item>
          <!--          <el-form-item  label="同步区域："  prop="syncRegions" class="pxy-form-item pxy-form-item-line">
                      <el-select size="small" v-model="form.syncRegions" multiple :multiple-limit="3" @change="syncRegionsChange">
                        <template v-for="(item, index) in syncRegionsList">
                          <el-option :key=index :label="item.regionName" :value="item.regionId"></el-option>
                        </template>
                      </el-select>
                      <el-tooltip  effect="light" content="" placement="top-start">
                        <div  slot="content" class="tip-info">
                          同步区域表示：在选中的集群中同步应用，您最多选择三个集群区域。推荐选择距离您较近的区域，降低访问延时。
                        </div>
                        <i class="el-icon-question tip-icon"></i>
                      </el-tooltip>
                    </el-form-item>
                    &lt;!&ndash;同步系数&ndash;&gt;
                    <el-form-item label="同步系数："  class="pxy-form-item pxy-form-item-line">
                      <el-input v-model="form.syncCoefficient" style="width:200px" size="small" disabled></el-input>
                      <el-tooltip  effect="light" content="" placement="top-start">
                        <div  slot="content" class="tip-info">
                          同步系数：同步系数是由（您的配额数/您选中的集群数量）计算出来的，表示一个集群区域需要同步几个节点，尽可能满足您的并发需要。
                        </div>
                        <i class="el-icon-question tip-icon"></i>
                      </el-tooltip>
                    </el-form-item>-->

          <!-- 启动参数-->
          <el-form-item label="启动参数：" prop="param" class="pxy-form-item">
            <el-input v-model="form.param" style="width: 300px" class="exeFile" size="small"
                      placeholder="请输入启动参数"></el-input>
            <el-tooltip effect="light" placement="top-start">
              <div slot="content" class="tip-info">
                Unreal引擎开发的应用程序有可能需要启动参数，
                可通过，本地直接运行->启动【任务管理器】->【详细信息】->鼠标置于状态栏，
                右键【选择列】->勾选【命令行】，->然后找到正在运行的UE4 课程，查看命令行参数
              </div>
              <i class="el-icon-question tip-icon"></i>
            </el-tooltip>
          </el-form-item>
          <el-collapse v-model="collapseActiveName" v-if="form.appliType == 2 || form.appliType == 14">
            <el-collapse-item title="高级设置" name="more">

              <!--窗口初始显示方式-->
              <el-form-item class="pxy-form-item pxy-form-item-line"
                            label="窗口初始显示方式：" prop="initWinSize">
                <el-select size="small" v-model="form.initWinSize" style="max-width:300px;width:100%;">
                  <el-option :key=0 label="按原始窗口大小显示（不超过终端屏幕）" :value=0></el-option>
                  <el-option :key=5 label="按应用原始窗口显示（超过终端屏幕出现滚动条）" :value=5></el-option>
                  <el-option :key=2 label="尽量填充容器（保存宽高比，不超过终端屏幕）" :value=2></el-option>
                  <el-option :key=10 label="优先垂直方向填充（保持宽高比，水平方向允许出现滚动条）" :value=10></el-option>
                  <el-option :key=15 label="优先垂直方向填充（保持宽高比，垂直方向允许出现滚动条）" :value=15></el-option>
                  <el-option :key=4 label="完全填充容器（拉伸）" :value=4></el-option>
                </el-select>
              </el-form-item>
              <!--初始化全屏模式-->
              <el-form-item v-if="form.appliType == 2" class="pxy-form-item pxy-form-item-line" label="初始化全屏模式："
                            prop="fullScreenMode">
                <el-select size="small" v-model="form.fullScreenMode" style="max-width:300px;width:100%;">
                  <!--手动触发-->
                  <el-option :key=0 label="手动触发" :value=0></el-option>
                  <!--首次点击屏幕-->
                  <el-option :key=1 label="首次点击屏幕" :value=1></el-option>
                  <!--每次点击屏幕-->
                  <el-option :key=2 label="每次点击屏幕" :value=2></el-option>
                </el-select>
              </el-form-item>
              <!--初始化分辨率-->
              <el-form-item v-if="form.appliType == 2" class="pxy-form-item pxy-form-item-line" label="初始化分辨率："
                            prop="initResolutionType">
                <el-select size="small" v-model="form.initResolutionType" style="max-width:300px;width:100%;">
                  <!--应用默认分辨率-->
                  <el-option :key=0 label="应用默认分辨率" :value=0></el-option>
                  <!--适应客户端窗口-->
                  <el-option :key=1 label="适应客户端窗口" :value=1></el-option>
                </el-select>
              </el-form-item>
              <!--初始背景色-->
              <el-form-item label="初始背景色：" class="pxy-form-item pxy-form-item-line">
                <el-input v-model="form.screenBgColor" style="max-width:300px;width:100%;" size="small"></el-input>
                <el-tooltip effect="light" placement="top-start">
                  <div slot="content" class="tip-info">*填写颜色的六位数编号</div>
                  <i class="el-icon-question tip-icon"></i>
                </el-tooltip>
                <!-- <el-tag type="warning">*填写颜色的六位数编号</el-tag> -->
              </el-form-item>
              <!-- 鼠标模式-->
              <el-form-item v-if="form.appliType == 2" label="鼠标模式：" prop="initCursorMode"
                            class="pxy-form-item pxy-form-item-line">
                <el-select size="small" v-model="form.initCursorMode" style="max-width:300px;width:100%;">
                  <el-option :key=0 label="非锁定模式" :value=0></el-option>
                  <el-option :key=1 label="锁定模式" :value=1></el-option>
                </el-select>
              </el-form-item>
              <!--触摸指令模式 鼠标模式（mouse）/触屏模式（touchScreen）-->
              <el-form-item label="触摸指令模式：" prop="touchOperateMode" class="pxy-form-item pxy-form-item-line">
                <el-select size="small" v-model="form.touchOperateMode" style="max-width:300px;width:100%;">
                  <el-option key="mouse" label="鼠标模式" value="mouse"></el-option>
                  <el-option key="touchScreen" label="触屏模式" value="touch"></el-option>
                </el-select>
              </el-form-item>
              <!--封面图-->
              <!--<el-form-item label="封面图"  prop="picUrl" class="pxy-form-item pxy-form-item-line">
                <el-upload
                  :action="picUpload.url"
                  :http-request="picUploadRequest"
                  accept=".png,.jpg"
                  name="add"
                  :show-file-list="false"
                  :on-remove="handlePicRemove">
                  <el-button size="small" type="primary">
                    &lt;!&ndash;  点击上传&ndash;&gt;
                    点击上传
                  </el-button>
                  <el-button  type="text" @click="clearPic($event)">清除</el-button >
                  <div slot="tip" class="el-upload__tip">
                    &lt;!&ndash;只能上传jpg/png文件&ndash;&gt;
                    只能上传jpg/png文件
                  </div>
                  <el-progress v-show="picUpload.showProgress" :text-inside="true" :stroke-width="16" :width=200
                               :percentage="picUpload.uploadPercent"></el-progress>
                  &lt;!&ndash; <div v-if="form.picUrl">{{form.picUrl}}</div>&ndash;&gt;
                  <img v-if="form.picUrl != ''" :src="form.picUrl" style="width: 100px;display: block"/>
                </el-upload>
              </el-form-item>-->
              <!-- 是否限制最大帧率-->
              <!--     <el-form-item  label="限制最大帧率" >
                     &lt;!&ndash;限制&ndash;&gt;
                     <el-radio v-model="form.limitMaxFps" :label=1>是</el-radio>
                     &lt;!&ndash; 不限制&ndash;&gt;
                     <el-radio v-model="form.limitMaxFps" :label=0>否</el-radio>
                   </el-form-item>-->
              <!-- 手机客户端时是否强制横屏-->
              <el-form-item label="强制横屏：" class="pxy-form-item pxy-form-item-line">
                <el-radio v-model="form.mobileForceLandscape" :label=1>是</el-radio>
                <el-radio v-model="form.mobileForceLandscape" :label=0>否</el-radio>
                <!-- <el-tooltip effect="light" placement="top-start">
                  <div slot="content" class="tip-info">*手机客户端是否强制横屏</div>
                  <i class="el-icon-question tip-icon"></i>
                </el-tooltip> -->
                <el-tag type="warning">*手机客户端是否强制横屏</el-tag>
              </el-form-item>

              <!-- 手机客户端是否初始显示虚拟摇杆-->
              <el-form-item label="显示虚拟摇杆：" class="pxy-form-item pxy-form-item-line">
                <el-radio v-model="form.mobileVirtualJoystick" :label=1>是</el-radio>
                <el-radio v-model="form.mobileVirtualJoystick" :label=0>否</el-radio>
                <!-- <el-tooltip effect="light" placement="top-start">
                  <div slot="content" class="tip-info">*手机客户端是否初始显示虚拟摇杆</div>
                  <i class="el-icon-question tip-icon"></i>
                </el-tooltip> -->
                <el-tag type="warning">*手机客户端是否初始显示虚拟摇杆</el-tag>
              </el-form-item>
              <!-- 应用是否支持手柄-->
              <el-form-item label="使用手柄：" class="pxy-form-item pxy-form-item-line">
                <el-radio v-model="form.useGamepad" :label=1>是</el-radio>
                <el-radio v-model="form.useGamepad" :label=0>否</el-radio>
                <!-- <el-tooltip effect="light" placement="top-start">
                  <div slot="content" class="tip-info">*应用是否支持手柄</div>
                  <i class="el-icon-question tip-icon"></i>
                </el-tooltip> -->
                <el-tag type="warning"> *应用是否支持手柄</el-tag>
              </el-form-item>
              <!-- 触屏放大手势与滚轮映射-->
              <!--  0:放大映射为鼠标滚轮向下，1:放大映射为鼠标滚轮向上*/-->
              <el-form-item label="" class="pxy-form-item pxy-form-item-line">
                <div class="pxy-tag-label">
                  <span>放大手势与滚轮映射：</span>
                </div>
                <el-radio v-model="form.mouseZoomDirection" :label=1>滚轮上滚</el-radio>
                <el-radio v-model="form.mouseZoomDirection" :label=0>滚轮下滚</el-radio>
                <!-- <el-tooltip effect="light" placement="top-start">
                  <div slot="content" class="tip-info">*触屏放大手势与滚轮映射</div>
                  <i class="el-icon-question tip-icon"></i>
                </el-tooltip> -->
                <el-tag type="warning">*触屏放大手势与滚轮映射</el-tag>
              </el-form-item>
              <!-- 互动模式是否显示玩家列表-->
              <el-form-item label="显示玩家列表：" class="pxy-form-item pxy-form-item-line">
                <!--显示-->
                <el-radio v-model="form.playerListToggle" :label=1>是</el-radio>
                <!-- 不显示-->
                <el-radio v-model="form.playerListToggle" :label=0>否</el-radio>
                <!-- <el-tooltip effect="light" placement="top-start">
                  <div slot="content" class="tip-info">*互动模式是否显示玩家列表</div>
                  <i class="el-icon-question tip-icon"></i>
                </el-tooltip> -->
                <el-tag type="warning">*互动模式是否显示玩家列表</el-tag>
              </el-form-item>
              <!--接口调用是否附加参数-->
              <el-form-item label="是否传递TaskId：" prop="hasExtraParam" class="pxy-form-item">
                <el-radio v-model="form.hasExtraParam" :label=1>是</el-radio>
                <el-radio v-model="form.hasExtraParam" :label=0>否</el-radio>
                <!-- <el-tooltip effect="light" placement="top-start">
                  <div slot="content" class="tip-info">*使用传递附加参数接口、数据通道等功能时需要传递TaskId</div>
                  <i class="el-icon-question tip-icon"></i>
                </el-tooltip> -->
                <el-tag type="warning"> *使用传递附加参数接口、数据通道等功能时需要传递TaskId</el-tag>
              </el-form-item>
              <!-- <el-form-item v-if="form.appliType == 2" label="文字输入事件提示：" class="pxy-form-item pxy-form-item-line" >
                 <el-radio v-model="form.textInputEventPrompt" :label=1>是</el-radio>
                 <el-radio v-model="form.textInputEventPrompt" :label=0>否</el-radio>
               </el-form-item>-->
              <el-form-item v-if="form.appliType == 2" label="移动端键盘类型：" class="pxy-form-item">
                <el-radio v-model="form.mobileKeyboardType" :label=0>系统键盘</el-radio>
                <el-radio v-model="form.mobileKeyboardType" :label=1>虚拟键盘</el-radio>
              </el-form-item>
              <el-form-item label="移动端全屏模式：" class="pxy-form-item" prop="mobileFullScreenMode">
                <el-radio v-model="form.mobileFullScreenMode" :label=0>手动触发</el-radio>
                <el-radio v-model="form.mobileFullScreenMode" :label=1>首次点击屏幕</el-radio>
                <el-radio v-model="form.mobileFullScreenMode" :label=2>每次点击屏幕</el-radio>
                <el-tag type="warning"> *ios系统不支持跳转全屏模式</el-tag>
              </el-form-item>
            </el-collapse-item>
          </el-collapse>
        </div>
        <p style="text-align: left;margin-top: 20px">组件服务</p>
        <div class="box-card clearfix is-always-shadow" style="margin-top: 10px">
          <el-form-item v-for="(item, index) in commItemList" :key="index"
                        label="" class="pxy-form-item pxy-form-item-line">
            <div class="pxy-tag-label">
              <span>{{item.itemName}}：</span>
              <el-checkbox v-if="item.required == '1'" checked="checked" disabled :key="item.id"
                           v-model="item.checkStatus">必选
              </el-checkbox>
              <el-checkbox v-else @change="changeContentHeight($event)" :key="item.id"
                           v-model="item.checkStatus"></el-checkbox>
            </div>
            <el-tag v-if="item.note" type="warning" v-html="item.note"></el-tag>
          </el-form-item>

        </div>

      </el-form>
      <div class="price-detail">
        <div class="item ">
          <div v-for="(item, index) in  commItemList" v-if="item.checkStatus">
            <span class="title">{{item.itemName}}：</span>
            <span class="unit">￥</span>
            <span class="price">{{item.price}}</span>
            <span class="unit"> {{item.priceUnit}}</span>
          </div>
        </div>
        <div class="item" style="">
          <el-button type="primary" class="pxy-primary" v-loading="loading" :disabled="loading" plain
                     @click="addAppli()">确认
          </el-button>
        </div>
      </div>
    </div>
    <!-- 通过微信扫码登录注册的用户，要求先补全用户信息再申请授权码 -->
    <el-dialog :visible.sync="inforSupplementVisible" width="600px" :close-on-click-modal="false" :close-on-press-escape="false" @close="inforSupplementClose">
      <p style="margin: 0 0 50px 0; font-size: 16px; margin-left: 100px;">温馨提示：微信登录用户，需补全用户信息再添加应用</p>
      <el-form :rules="userInfoFormRules" :model="userInfoForm" ref="userInfoForm" class="reg-form" label-position="right"
               label-width="100px" auto-complete="off">
        <el-input type="password" style="position: fixed;bottom: -9999px"></el-input>

        <el-form-item prop="accountId" label="账户名：">
          <el-input placeholder="账户名" v-model="userInfoForm.accountId" class="login-id" disabled>
            <!-- <el-select v-model="form.role" slot="append" placeholder="账号类型" style="width: 107px">
              <el-option :key=1 label="个人用户" :value=1>
              </el-option>
              <el-option :key=2 label="企业用户" :value=2>
              </el-option>
            </el-select> -->
          </el-input>
        </el-form-item>
        <el-form-item prop="mobile" label="手机号：">
          <!-- <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16"> -->
            <el-input v-model="userInfoForm.mobile" auto-complete="off" placeholder="手机号" name="mobile" class="input-with-select">
              <el-select v-model="userInfoForm.countryMob" slot="prepend" placeholder="请选择" class="country-mobile-select">
                <el-option v-for="item in countryList" :key="item.value" :value="item.value">{{item.label}}&nbsp;&nbsp;{{item.value}}</el-option>
              </el-select>
            </el-input>
          <!-- </el-col> -->
          <!-- <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8" class="sendBtn send-btn">
                  <smsCode :mobile="form.mobile" type="1" :countryMob="form.countryMob" :captcha="form.verifyCode" :captchaId="captchaId" @changeCaptcha="change"></smsCode>
          </el-col> -->
        </el-form-item>
        <el-form-item prop="email" label="邮箱：">
          <el-input class="col-md-12" type="text" v-model="userInfoForm.email"
                    placeholder="邮箱"></el-input>
        </el-form-item>

        <el-form-item label="地址：">
          <el-select  v-model="userInfoForm.provinceIndex" filterable placeholder="省份" @change="getCityList($event)" style="width: 49%;margin-right: 1%;">
            <el-option
              v-for="(item,index) in provinceList"
              :key="index"
              :label="item.province"
              :value="index">
            </el-option>
          </el-select>
          <el-select v-model="userInfoForm.cityIndex" filterable placeholder="城市" style="width: 50%">
            <el-option
              v-for="(item,index) in cityList"
              :key="index"
              :label="item.city"
              :value="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="company" label="公司名称：">
          <el-input class="col-md-12" type="text" v-model="userInfoForm.company" auto-complete="off"
                    placeholder="公司名称" name="company"></el-input>
        </el-form-item>
        <div style="display: flex;">
          <label class="reg-form-label">业务领域：</label>
          <div style="display: flex;width:calc(100% - 100px);justify-content: space-between;">
            <el-form-item  prop="busiScope" class="reg-form-item" style="width: 49%;">
              <el-select class="col-md-12" v-model="userInfoForm.busiScope" filterable placeholder="业务领域" style="width: 100%">
                <el-option
                  v-for="item in busiScopeList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item  prop="jobTitle" class="reg-form-item" style="width: 50%;">
              <el-select class="col-md-12" v-model="userInfoForm.jobTitle" filterable placeholder="岗位" style="width: 100%">
                <el-option
                  v-for="item in jobTitleList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <el-form-item class="reg-form-item">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-button type="primary" style="width: 100%" @click.native.prevent="supplementFn">提交</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {Message} from "element-ui";
  import axios from 'axios'
  import comm from '@/utils/comm'
  import Simple from './simpleUploader';
  import * as zip from "@zip.js/zip.js";
  import $ from 'jquery'
  const countryList = [
    {label: '中国/China', value: '+86'},
    {label: '中国香港/Hong Kong', value: '+852'},
    {label: '中国台湾/Taiwan', value: '+886'},
    {label: '中国澳门/Macao', value: '+853'},
    {label: '澳大利亚/Austria', value: '+61'},
    {label: '加拿大/Canada', value: '+1'},
    {label: '瑞士/Switzerland', value: '+41'},
    {label: '德国/Germany', value: '+49'},
    {label: '丹麦/Denmark', value: '+45'},
    {label: '法国/France', value: '+33'},
    {label: '英国/United Kingdom', value: '+44'},
    {label: '爱尔兰/Ireland', value: '+353'},
    {label: '意大利/Italy', value: '+39'},
    {label: '日本/Japan', value: '+81'},
    {label: '韩国/South Korea', value: '+82'},
    {label: '开曼群岛/Cayman Islands', value: '+1345'},
    {label: '马尔代夫/Maldives', value: '+960'},
    {label: '墨西哥/Mexico', value: '+52'},
    {label: '马来西亚/Malaysia', value: '+60'},
    {label: '荷兰/Netherlands', value: '+31'},
    {label: '挪威/Norway', value: '+47'},
    {label: '新西兰/New Zealand', value: '+64'},
    {label: '新加坡/Singapore', value: '+65'},
  ]

  zip.configure({useWebWorkers: false});
  export default {
    components: {Simple},
    data() {
      return {
        exeTabShowFlag: true,
        collapseActiveName: '',
        loading: false,
        commItemList: [], //通用计价规则
        basicItem_2k: {},
        basicItem_4k: {},
        form: {
          appliName: '',
          //应用类型
          /* Integer APPLI_TYPE_DESKTOP = 1;  //SR(独占)
       Integer APPLI_TYPE_SHARED = 2;   //SR(共享)
       Integer APPLI_TYPE_VR = 3;       //VR(SteamVR)
       Integer APPLI_TYPE_PXY_AR = 9;   //AR(PXY)
       Integer APPLI_TYPE_NV_AR = 11;   //AR(Nvidia)*/
          appliType: 2,
          isWebGL: 0,

          //计费方式:1包月,2按量付费
          chargeType: 2,
          instanceMax: 5,
          zipFile: '',
          appliPath: '',
          fileSize: 0,
          picUrl: '',
          exeFilePath: '',
          param: '',
          hasExtraParam: 0,
          initWinSize: 0,
          initCursorMode: 0,
          initResolutionType: 0,
          fullScreenMode: 0,
          screenBgColor: '',
          //应用是否支持手柄，默认值0：否
          useGamepad: 0,
          //手机客户端时是否强制横屏，默认值1：是
          mobileForceLandscape: 1,
          //手机客户端是否初始显示虚拟摇杆，默认值1：是
          mobileVirtualJoystick: 1,
          //移动端放大操作与应用鼠标滚轮的对应关系
          //0:鼠标滚轮向下为放大，1:鼠标滚轮向上为放大
          mouseZoomDirection: 1,
          //协同模式用户列表是否显示，1：显示；0：不显示
          playerListToggle: 1,
          //是否限制最大帧率，1：限制
          limitMaxFps: 1,
          touchOperateMode: 'mouse',
          status: '0',
          exeFileNameSuffix: '.exe',
          dcsFlag: false,
          playModeFlag: false,
          vrClassFlag: false,
          sdkSnFlag: false,
          audioInputFlag: false,
          videoInputFlag: false,
          liveStreamingFlag: false,
          initiativeSyncFlag: 2, // 同步类型
          syncRegions: [], //同步区域
          syncCoefficient: '', // 同步系数
          serverStandard: '2k',
          noOperaTimeout: 5,
          textInputEventPrompt: 1,
          mobileKeyboardType: 0, //移动端键盘类型
          mobileFullScreenMode: 0, // 移动端全屏模式
          serviceItemList: []
        },
        syncRegionsList: [], //同步区域下拉
        uploadCourse: {
          url: '/appli/upload',
          /*   url: 'https://larkxrpub.pingxingyun.com/vrAppli/upload',*/
          //控制上传次数
          i: 0,
          j: 0,
          showProgress: false,
          uploadPercent: 0,
          showSectionFileName: true,
          xhr: null,
          addBtnDisabled: false,
        },
        picUpload: {
          url: '/appli/uploadPic',
          //控制上传次数
          i: 0,
          j: 0,
          showProgress: false,
          uploadPercent: 0,
          showSectionFileName: true
        },
        rules: {
          appliName: [
            //请输入应用名称
            {
              required: true,
              message: "请输入应用名称",
              trigger: 'blur'
            },
            //长度在64个字符以内
            {max: 64, message: "长度在64个字符以内", trigger: 'blur'}
          ],
          param: [
            //长度在512个字符以内
            {max: 512, message: "长度在512个字符以内", trigger: 'blur'}
          ],

          appliPath: [
            /* 请上传应用*/
            {required: true, message: '请上传应用', trigger: 'change'},
          ],
          exeFilePath: [{required: true, message: '请输入应用存储路径', trigger: 'blur'}],
          syncRegions: [{required: true, message: '请选择同步区域', trigger: 'blur'}]
        },
        //内容的整体高度class
        heightC: 'heightN0',
        //增值服务的开启数量
        extraCnt: 0,
        exeFilePathList: [],
        //zipContentList: [],
        zipContentListValue: '',
        chunkSize: 5 * 1024 * 1024,
        maybeUnreal: false, // 是否检测到上传的应用可能是Unreal引擎,
        inforSupplementVisible: false,
        countryList: countryList,
        userInfoFormRules: {
          accountId: [{required: true, message: '请输入账户名', trigger: 'blur'},
            {max: 50, message: "长度在50个字符以内", trigger: 'blur'}],
          smsCode: [{required: true, message: '请输入验证码', trigger: 'blur'}],
          email: [
            {required: true, message: '请输入邮箱', trigger: 'blur'},
            { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
          ],
          mobile: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            {max: 16, message: "长度在16个字符以内", trigger: 'blur'},
            // {type: 'number', message: '请输入正确手机号', trigger: 'blur'}
          ],
          company: [{required: true, message: '请输入公司名称', trigger: 'blur'}],
          busiScope: [{required: true, message: '请选择业务领域', trigger: 'blur'}],
          jobTitle: [{required: true, message: '请选择岗位', trigger: 'blur'}],
        },
        captchaId: '',
        userInfoForm: {
          accountId: '',
          mobile: '',
          email: '',
          // password: '',
          // verifyCode: '', //图片验证码
          // smsCode: '', //手机验证码
          role: 1,
          // confirmPassword:'',
          provinceIndex:'',
          cityIndex:'',
          company:'',
          busiScope:'',
          jobTitle:'',
          // source: '', // 渠道
          // term: '', // 关键词
          countryMob: '+86'
        },
        busiScopeList:[
          "数字孪生",
          "教育教学",
          "展览展示",
          "游戏娱乐",
          "虚拟直播",
          "虚拟演出",
          "3D品牌营销",
          "数字藏品",
          "超写实数字人",
          "其他"
        ],
        jobTitleList:[
          "研发工程师",
          "研发负责人",
          "公司负责人",
          "部门负责人",
          "商务销售人员",
          "教师",
          "学生",
          "其他"
        ],
        provinceList:[],
        cityList:[],
      }
    },
    methods: {
      // 渲染类型更改
      appliTypeChange(val) {
        if (val === 14) {
          this.form.audioInputFlag = false;
        }else if(val == 16){
          this.form.isWebGL = 1
        }
      },
      getProcProdItem: function () {
        this.getRequest('/pocPriceItem/list', {"type": 3}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.commItemList = resp.data.result;
              this.basicItem_2k = this.commItemList.filter(item => item.id == '876869352356547789')[0];
              this.basicItem_4k = this.commItemList.filter(item => item.id == '876869353356547889')[0];
              if (this.form.serverStandard == '2k') {
                this.commItemList = this.commItemList.filter(item => item.id != '876869353356547889')
              } else if (this.form.serverStandard == '4k') {
                this.commItemList = this.commItemList.filter(item => item.id != '876869352356547789')
              }
              this.updateCommonListCheckStatus()
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      updateCommonListCheckStatus: function () {
        //检查用户是否设置了定制Logo
        // yes:需选中定制Logo增值服务,并设置成必选
        // no: 移除定制定制Logo增值服务
        this.getRequest('/pocOrder/getByUserIdAndType', {"type": 5}).then(resp => {
          if (resp.status == 200 && resp.data.code == 1000 && resp.data.result.length > 0) {
            this.commItemList.forEach((item, index) => {
              if (item.id == '917789292326027264' || //定制Logo
                item.id == '876869353356547889' || //基础服务
                item.id == '876869352356547789') //基础服务
              {
                this.$set(item, 'checkStatus', true);
                this.$set(item, 'required', 1);
              } else {
                this.$set(item, 'checkStatus', false);
              }
            })
          } else {
            this.commItemList = this.commItemList.filter(item => item.id != '917789292326027264') //移除定制定制Logo增值服务
            this.commItemList.forEach((item, index) => {
              if (item.id == '876869353356547889' || //基础服务
                item.id == '876869352356547789') //基础服务
              {
                this.$set(item, 'checkStatus', true);
              } else {
                this.$set(item, 'checkStatus', false);
              }

            })
          }
        })
      },

      addAppli: function () {
        var _this = this;
        var params = {};
        params.appliName = _this.form.appliName;
        params.appliType = _this.form.appliType;
        params.isWebGL = _this.form.isWebGL;
        params.chargeType = _this.form.chargeType;
        // params.instanceMax = _this.form.instanceMax;
        params.zipFile = _this.form.zipFile;
        params.appliPath = _this.form.appliPath;
        params.fileSize = _this.form.fileSize;
        /*       params.picUrl = _this.form.picUrl;*/
        params.exeFilePath = _this.form.exeFilePath;
        params.exeFilePathList = _this.exeFilePathList.join(),
          params.param = _this.form.param;
        params.hasExtraParam = _this.form.hasExtraParam;
        params.initWinSize = _this.form.initWinSize;
        params.initCursorMode = _this.form.initCursorMode;
        params.initResolutionType = _this.form.initResolutionType;
        params.fullScreenMode = _this.form.fullScreenMode;
        params.screenBgColor = _this.form.screenBgColor;
        params.useGamepad = _this.form.useGamepad;
        params.mobileForceLandscape = _this.form.mobileForceLandscape;
        params.mobileVirtualJoystick = _this.form.mobileVirtualJoystick;
        params.mouseZoomDirection = _this.form.mouseZoomDirection;
        params.playerListToggle = _this.form.playerListToggle;
        params.limitMaxFps = _this.form.limitMaxFps;
        params.touchOperateMode = _this.form.touchOperateMode;
        params.status = _this.form.status;
        params.exeFileNameSuffix = _this.form.exeFileNameSuffix;
        params.maxConnCnt = _this.form.instanceMax;
        /*以下几个注释的参数后台根据serviceItemList动态设置，不需要在前台传递
         params.dcs = _this.form.dcsFlag ? '1' : '0';
         params.playMode = _this.form.playModeFlag ? '1' : '0';
         params.vrRoom = _this.form.vrClassFlag ? '1' : '0';
         params.sdkAuth =  _this.form.sdkSnFlag ? '1' :'0' ;
         params.audioInput = _this.form.audioInputFlag ? '1' :'0' ;
         params.videoInput = _this.form.videoInputFlag ? '1' :'0' ;
         params.liveStreaming = _this.form.liveStreamingFlag ? '1' :'0' ;*/
        params.serverStandard = _this.form.serverStandard;
        params.noOperaTimeout = _this.form.noOperaTimeout;
        params.tag = _this.form.tag;
        params.initiativeSyncFlag = _this.form.initiativeSyncFlag;// 同步类型
        params.syncRegions = _this.form.syncRegions.join('|'); // 同步区域
        params.syncCoefficient = _this.form.syncCoefficient;//同步系数
        params.mobileFullScreenMode = _this.form.mobileFullScreenMode; //移动端全屏类型
        //params.userId = _this.$store.user.userId;
        // 2D共享模式不支持下面功能
        if (this.form.appliType == 2) {
          params.textInputEventPrompt = _this.form.textInputEventPrompt;//是否开启文字输入事件提示
          params.mobileKeyboardType = _this.form.mobileKeyboardType; // 移动端键盘类型
        }
        //只保留选中组件的价格说明
        params.serviceItemList = this.commItemList.filter(item => item.checkStatus);
        this.$refs["form"].validate((valid) => {
          if (valid) {
            //this.$confirm('对于长时间不使用的应用，系统将会对程序包做定期清理，上传之后请尽快使用', '温馨提示', {
            this.$confirm('如果欠费状态下，托管应用将立即停用。若欠费超过30天，应用将被系统自动删除。未使用且无实际充值超过30天的应用将被视为僵尸应用，同样会被删除。若超过一年未登录平台，账户下的所有应用将被删除。请保持账户活跃并确保余额充足。', '温馨提示', {
              confirmButtonText: '知道了',
              /*     cancelButtonText: '关闭',*/
              type: 'warning',
              center: true
            }).then(() => {
              _this.doAddAppli(params);
            }).catch(() => {

            });

          }
        })
      },
      doAddAppli: function (params) {
        this.loading = true;
        this.postRequestJson('/poc/hostAppli/add', JSON.stringify(params)).then(resp => {
          this.loading = false;
          if (resp && resp.status == 200) {
            var data = resp.data;
            if (data.code == 1000) {
              Message.success(data.message);
              this.$router.replace({path: '/appli/index'});

            } else {
              Message.error(data.message);

            }
          }
        });
      },
      changeIsWebGLFlag: function(e){
        if(e === 1){
          this.form.exeFilePath = this.$webGLExePath
        }
      },
      changeContentHeight: function (flag) {
        if (flag) {
          this.extraCnt += 1;
        } else {
          this.extraCnt -= 1;
        }
        this.heightC = 'heightN' + this.extraCnt;
      },
      changeServerStandard: function (e) {
        this.commItemList = this.commItemList.filter(item => item.id != '876869353356547889')
        this.commItemList = this.commItemList.filter(item => item.id != '876869352356547789');
        if (e == '2k') {
          this.commItemList.unshift(this.basicItem_2k)
        } else if (e == '4k') {
          this.commItemList.unshift(this.basicItem_4k)
        }
      },
      courseUploadRequest(f) {
        var _this = this;
        _this.exeTabShowFlag = true;
        _this.uploadCourse.addBtnDisabled = true;
        var param = new FormData(); //创建form对象
        param.append('zipFile', f.file);//通过append向form对象添加数据
        //param.append('vrFile', f.file);//通过append向form对象添加数据
        _this.fileSize = f.file.size;
        axios.defaults.withCredentials = true;
        axios({
          method: 'post',
          url: _this.$larkXRUrl + f.action,
          data: param,
          // `onUploadProgress` 允许为上传处理进度事件
          onUploadProgress: function (progressEvent) {
            // 对原生进度事件的处理
            _this.courseProgressFunction(progressEvent)
          },
          headers: {
            'Content-Type': 'multipart/form-data',
            'adminKey': '603284317954637824',
            'timestamp': '8641637304472330',
            'signature': '4A7E6678D418163B31FC84CDDCD25F75B1E51098'
          }
        }).then(resp => {
          if (resp && resp.status == 200) {
            var data = resp.data;
            if (data.code == 1000) {
              _this.uploadCourse.uploadPercent = 100;
              _this.form.appliPath = data.result.appliPath;
              _this.form.zipFile = data.result.zipFilePath;
              _this.form.fileSize = data.result.fileSize;
              //检查应用大小按照存储容量计费
              // _this.setStorageFee();
              if (data.result.exeFilePathList && data.result.exeFilePathList.length > 0) {
                _this.exeFilePathList = data.result.exeFilePathList
              }
              this.$message({type: data.code, message: data.message});
            } else {
              _this.uploadCourse.uploadPercent = 0;
              _this.form.appliPath = '';
              _this.form.zipFile = '';
              _this.form.fileSize = '';
              _this.exeFilePathList = [];
              this.$message({type: data.code, message: data.message});
            }
            _this.uploadCourse.addBtnDisabled = false;
          }
        })
      },
      courseProgressFunction: function (fun) {
        if (this.uploadCourse.i == 0) { //控制上传中状态只执行一次上传
          this.uploadCourse.showProgress = true;
          this.uploadCourse.i = 1;
        }
        if (fun.total != 0) {
          this.uploadCourse.uploadPercent = parseInt((fun.loaded / fun.total).toFixed(2) * 100);
        }
        if (this.uploadCourse.uploadPercent >= 90) {
          this.uploadCourse.uploadPercent = 90;
        }
      },
      async beforeUpload(file) {
        try {
          const _this = this;
          // 前端解压
          const reader = new zip.ZipReader(new zip.BlobReader(file), {filenameEncoding: 'gbk'});
          const entries = await reader.getEntries();
          if (entries.length) {
            let wantFiles = [];
            _this.maybeUnreal = false;
            entries.forEach(item => {
              if (item.filename.indexOf('.exe') !== -1) {
                wantFiles.push(item.filename)
                // 是否检测到应用可能是Unreal引擎
                if (item.filename.indexOf('Binaries') !== -1) {
                  _this.maybeUnreal = true;
                  _this.form.exeFilePath = item.filename;
                } else {
                  // 如果不是Unreal引擎应用，执行文件路径为空，让用户自己选择
                  if (!_this.maybeUnreal) _this.form.exeFilePath = "";
                }
              }
            })
            this.exeFilePathList = wantFiles;
          }
          // close the ZipReader
          await reader.close();

        } catch (e) {
          console.log("解压出错了：", e)
          this.$message("解压出错了,请以原生zip方式压缩程序包，例如：右键->发送到->压缩(zipped)文件")
        }

      },
      picUploadRequest(f) {
        var _this = this;
        var param = new FormData(); //创建form对象
        param.append('picFile', f.file);//通过append向form对象添加数据
        axios({
          method: 'post',
          url: _this.$larkXRUrl + f.action,
          data: param,
          // `onUploadProgress` 允许为上传处理进度事件
          onUploadProgress: function (progressEvent) {
            // 对原生进度事件的处理
            _this.picProgressFunction(progressEvent)
          },
          headers: {
            'Content-Type': 'multipart/form-data',
            'adminKey': '603284317954637824',
            'timestamp': '8641637304472330',
            'signature': '4A7E6678D418163B31FC84CDDCD25F75B1E51098',
            'authorization': _this.$store.state.user ? _this.$store.state.user.token : null
          }
        }).then(resp => {
          if (resp && resp.status == 200) {
            var data = resp.data;
            if (data.code == 1000) {
              _this.picUpload.uploadPercent = 100;
              _this.form.picUrl = data.result.fileName;
              this.$message({type: data.code, message: data.message});
            } else {
              _this.picUpload.uploadPercent = 0;
              this.$message({type: data.code, message: data.message});
            }
          } else {
            this.$message({type: resp.status, message: resp.statusText});
          }
        })
      },
      picProgressFunction: function (fun) {
        if (this.picUpload.i == 0) { //控制上传中状态只执行一次上传
          this.picUpload.showProgress = true;
          this.picUpload.i = 1;
        }
        if (fun.total != 0) {
          this.picUpload.uploadPercent = parseInt((fun.loaded / fun.total).toFixed(2) * 100);
        }
        if (this.picUpload.uploadPercent >= 90) {
          this.picUpload.uploadPercent = 90;
        }
      },
      handlePicRemove() {
        this.picUrl = "";
        this.picUpload.uploadPercent = 0;
      },
      clearPic(e) {
        if (e && e.stopPropagation) {
          e.stopPropagation();
        } else {
          window.event.cancelBubble = true;
        }
        this.$confirm("删除封面图？",
          '是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
          this.doClearPic();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      doClearPic() {
        this.postRequest("/vrAppli/deletePicPath", {
          appliId: "",
          picFileName: this.form.picUrl
        }).then(resp => {
          if (resp && resp.status == 200) {
            var data = resp.data;
            this.form.picUrl = "";
            this.picUpload.showProgress = false;
            this.picUpload.uploadPercent = 0;
            this.$message({type: data.status, message: data.message});
          }
        });
      },
      success(data) {
        this.$message('上传成功');
        this.form.appliPath = data.appliPath;
        this.form.zipFile = data.zipFile;
        this.form.fileSize = data.fileSize;
        //如果后端解压回来执行路径list，就覆盖掉前端解压出来的路径list
        if (data.exeFilePathList.length > 0) this.exeFilePathList = data.exeFilePathList;
        console.log(this.form)
      },
      getProvinceList(){
        this.getRequest('/uacLocationProvince/getProvinceList').then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.provinceList = resp.data.result;
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      getCityList(event){
        this.getRequest('/uacLocationCity/getList',{'pid':this.provinceList[event].pid}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.cityList = resp.data.result;
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      supplementFn() {
        var _this = this;
        this.userInfoForm.mobile = this.userInfoForm.countryMob==='+86' ? this.userInfoForm.mobile : this.userInfoForm.countryMob + this.userInfoForm.mobile;

        var regPos = /^[0-9]+.?[0-9]*$/;
        if(regPos.test(this.userInfoForm.provinceIndex)){
          this.userInfoForm.province = _this.provinceList[this.userInfoForm.provinceIndex].province;
        }else {
          this.userInfoForm.province = this.userInfoForm.provinceIndex;
        }

        if(regPos.test(this.userInfoForm.cityIndex)){
          this.userInfoForm.city = _this.cityList[this.userInfoForm.cityIndex].city;
        }else {
          this.userInfoForm.city = this.userInfoForm.cityIndex;
        }
        const params = {
          ...this.userInfoForm,
          userId: this.user.userId
        }
        this.$refs['userInfoForm'].validate((valid) => {
          if (valid) {
            this.postRequestJson('/uacUser/update', JSON.stringify(params)).then(resp => {
              if (resp && resp.status == 200) {
                const data = resp.data;
                if (data.code == 1000) {
                  const result = Object.assign(data.result, {
                    token: this.user.token
                  });
                  this.$store.commit('login', result);
                  this.inforSupplementVisible = false;

                  // marketup表单数据采集
                  // this.submitFormToMarket(params);
                } else {
                  Message.error(data.message);
                }
              }
            });
          }
        })
      },
      submitFormToMarket(params) {
        const marketupWidget = new window._MARKETUP_CHAT.Widget({
          base: 'https://paraverse.marketup.cn',
        })
        if(marketupWidget) {
          const paramsObj = {
            _username: params.accountId,
            _mobile_phone: params.mobile,
            company_address: params.province + params.city,
            _company: params.company,
            business_type: params.busiScope, // 业务领域
            position: params.jobTitle   // 岗位
          }
          marketupWidget.submitFormData({websiteFormId:4370857068410881,data: paramsObj});
        }
      },
      inforSupplementClose() {
        if(!this.user.mobile){
          this.$router.push('/appli/index');
        }
      }
    },
    mounted: function () {
      if(!this.user.mobile){
        this.userInfoForm.accountId = this.user.accountId;
        console.log(window.location)
        window.history.pushState({ path: window.location.pathname+'?utm_source=weixinsaoma#/appli/add' }, '', window.location.pathname+'?utm_source=weixinsaoma#/appli/add');
        // this.$router.replace({
        //   path: '/appli/add',
        //   query: {
        //     utm_source: 'weixinsaoma'
        //   }
        // })
        this.inforSupplementVisible = true;
        this.getProvinceList();
        // // marketup埋点-----start
        const script = document.createElement('script');
        script.src = 'https://www.marketup.cn/resources/js/analytics.js';
        script.onload = () => {
          var analytics  = new window._MARKETUP_ANALYTICS.Analytics({base:'https://paraverse.marketup.cn',siteId:4364007118682113})
          analytics.page()
        };
        document.head.appendChild(script);
        const marketupScript_1 = document.createElement('script');
        marketupScript_1.type = 'text/javascript';
        marketupScript_1.src = 'https://www.marketup.cn/resources/js/floatingbar/floatingbar.js';
        document.body.appendChild(marketupScript_1);
        // marketup埋点-----end
      }
      this.getProcProdItem();
      comm.addHeartBeat();
      window.onbeforeunload = e => {      //刷新时弹出提示
        return ''
      };
    }
    ,
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    watch: {
      // 'form.webGLUrl': function (newVal, oldVal) {
      //   if (this.form.isWebGL == 1) {
      //     //this.form.param = "--use-views --initial-show-state=maximized --hide-controls --hide-frame --enable-gpu --url=" + newVal;
      //     this.form.appliType = 16
      //   }
      // }
    },
    destroyed() {
      window.onbeforeunload = null
    },
    beforeRouteLeave(to, from, next) {
      // 导航离开该组件的对应路由时调用
      // 可以访问组件实例 `this`
      // 该导航可以通过 next(false) 来取消。
      if (!(this.uploadCourse.uploadPercent == 0 || this.uploadCourse.uploadPercent == 100)
        && (this.picUpload.uploadPercent == 0 || this.picUpload.uploadPercent == 100)) {
        const answer = window.confirm("应用程序正在上传，确定离开此页面吗?")
        if (answer) {
          next()
        } else {
          // 不支持传递回调(因为this实例已经创建可以获取到，所以没必要)
          next(false)
        }
      } else {
        next();
      }
    },
    beforeDestroy() {

    }
  }
</script>
<style lang="scss" scoped>
  .sn-content .pxy-form-item .el-checkbox {
    float: none;
  }

  .box-card {
    text-align: left;
    border: 1px solid #EBEEF5;
    background-color: #FFF;
    color: #303133;
    border-radius: 4px;
    padding: 20px;
  }

  .tip-icon {
    margin-left: 10px;
    font-size: 18px;
    cursor: pointer;
    color: #DCDFE6;
  }

  .tip-icon:hover {
    color: #FF6B00;
  }

  .tip-info {
    width: 100%;
    max-width: 330px;
  }

  @media screen and (max-width: 768px) {
    /* 1px solid #EBEEF5 */
    .pxy-form-item .el-form-item__content .el-tag {
      height: auto !important;
      white-space: normal !important;
    }
    .pxy-form-item {

      margin-bottom: 10px !important;
      padding-bottom: 15px !important;
      box-sizing: border-box !important;
    }
    .pxy-form-item-line {
      border-bottom: 1px solid #EBEEF5 !important;
    }
    .el-upload {
      width: 100%;
    }
    ::v-deep .pxy-upload .el-upload .el-upload-dragger {
      width: 100% !important;
    }
  }

  @media screen and (min-width: 769px) {
    .pxy-form-item .el-form-item__content {
      margin-left: 0 !important;
    }
    .pxy-form-item .el-form-item__content .el-tag {
      margin-left: 10px !important;
    }
    ::v-deep .pxy-form-item .el-form-item__content .el-form-item__error {
      left: 155px !important;
    }
    .pxy-tag-label {
      display: inline-block;
    }
  }
</style>
